import { render, staticRenderFns } from "./ShowAuthorityList.vue?vue&type=template&id=3cf4c80d&"
import script from "./ShowAuthorityList.vue?vue&type=script&lang=js&"
export * from "./ShowAuthorityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports